import { useSnackbar } from 'notistack'
import PinInput from 'react-pin-input'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useSendKeyCodePasswordChange } from '~/features/auth/queries/useAuth'
import Close from '~/shared/assets/icons/Close'
import { isModalOpenState, keyCodeState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function PasswordChangeInputCodeModal() {
  const { enqueueSnackbar } = useSnackbar()
  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)
  const [passwordChangeKeyCode, setPasswordChangeKeyCode] =
    useRecoilState(keyCodeState)

  const { mutate: sendKeyCodePasswordChangeMutate } =
    useSendKeyCodePasswordChange()

  const checkCertCode = (value: string) => {
    setPasswordChangeKeyCode({
      ...passwordChangeKeyCode,
      code: value,
    })

    sendKeyCodePasswordChangeMutate(
      { key: passwordChangeKeyCode.key, code: value },
      {
        onSuccess: (res) => {
          if (res.errorCode === -2101) {
            enqueueSnackbar(res.errorMsg, { variant: 'error' })
          } else {
            enqueueSnackbar('이메일 인증이 완료되었습니다.', {
              variant: 'success',
            })
            setIsModalOpen({ contents: 'password-reset', isOpen: true })
          }
        },
      },
    )
  }

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() =>
          setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
        }
      />
      <MainText>코드 입력</MainText>
      <Desc>이메일로 받으신 코드 6자리를 입력해 주세요.</Desc>

      <PinInput
        length={6}
        type="numeric"
        placeholder="0"
        inputMode="number"
        inputStyle={{
          width: '70px',
          height: '70px',
          margin: '5px',
          borderRadius: '10px',
          border: '1px solid #c1c3c2',
          fontSize: '36px',
          fontWeight: '600',
          color: '#8bd2d7',
        }}
        inputFocusStyle={{
          border: '1px solid #8bd2d7',
          color: '#8bd2d7',
          fontSize: '36px',
          fontWeight: '600',
        }}
        onComplete={checkCertCode}
        autoSelect={true}
      />
    </Wrapper>
  )
}

export default PasswordChangeInputCodeModal

const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  box-sizing: border-box;
  min-width: 40%;
  margin: 0 auto;
  padding: 108px 0 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    gap: 0;
    justify-content: center;

    box-sizing: border-box;
    width: 90%;
    max-height: 80%;
    padding: 56px 0 30px;

    & > .pincode-input-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      width: 80%;
      margin: 0 auto;
    }
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const MainText = styled.h1`
  width: ${theme.calculatePcVw(580)};

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 140%;
  text-align: center;

  @media ${theme.device.medium} {
    width: 80%;
    height: 100px;

    font-size: 36px;
    font-weight: 500;
    line-height: 140%;
  }
`

const Desc = styled.p`
  width: 80%;
  height: 75px;
  line-height: 30px;
  text-align: center;
`
